var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Divider, Popover, Stack } from "@mui/material";
import { ButtonV2 } from "../../Atoms";
import { COLORS } from "../../../constants";
var ActionablePopover = function (_a) {
    var actions = _a.actions, anchorEl = _a.anchorEl, handleClose = _a.handleClose;
    return (_jsx(Popover, __assign({ id: "actionable-popover", open: !!anchorEl, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
            vertical: "top",
            horizontal: "left",
        }, transformOrigin: {
            vertical: "bottom",
            horizontal: "left",
        } }, { children: _jsx(Stack, __assign({ px: 2.5, py: 3.5, gap: 3.5, alignItems: "flex-start", borderRadius: 2, border: "1px solid ".concat(COLORS.P_OUTLINE) }, { children: actions.map(function (_a, idx) {
                var text = _a.text, testid = _a.testid, action = __rest(_a, ["text", "testid"]);
                return (_jsxs(React.Fragment, { children: [_jsx(ButtonV2, __assign({ "data-testid": testid, variant: action.variant || "textSecondary", size: "small" }, action, { children: text })), idx !== actions.length - 1 && (_jsx(Divider, { sx: { width: "100%", m: 0 }, variant: "middle" }))] }, text));
            }) })) })));
};
export default ActionablePopover;
